import type { ReactNode } from 'react';

import { cn } from '@mds/shared/lib/utils';

/**
 * A small uppercase tag. `className` replaces the default border/fill, it does not add to it.
 * `size="sm"` is the compact tag for a dense table.
 */
export default function Chip({
  children,
  className,
  size,
}: {
  children: ReactNode;
  className?: string;
  size?: 'sm';
}) {
  return (
    <span
      className={cn(
        'inline-flex max-w-full items-center rounded-full border px-3 py-1.5 font-mono text-sm font-semibold tracking-label whitespace-nowrap uppercase max-sm:whitespace-normal',
        size === 'sm' && 'px-2 py-0.5 text-2xs',
        className ?? 'border-hairline bg-surface text-ink-secondary',
      )}
    >
      {children}
    </span>
  );
}
